import { Injectable } from '@angular/core';
// import { DatatransferService } from '../../../dashboard/dashboard2/datatransfer.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class Co2detailService {
  myMainTest : any;

  constructor(private _http: HttpClient,
    // private DatatransferService : DatatransferService
    ) {


  }

  co2DetailCards(id, apiToken: string) {
   
    return this._http.get("https://api.cognition.world/v1/quality/coo/details/cards/" + id, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }

 

  co2DetailChart1X(id, tempDate3, apiToken: string) {
   
    return this._http.get("https://api.cognition.world/v1/quality/coo/details/hist/" + id + "-" + tempDate3, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }


  chartTempLoad(id, startDay, endDay, apiToken: string) {
    return this._http.get("https://api.cognition.world/v1/quality/coo/details/hist/" + id + "-" + startDay + "-" + endDay, {headers:{'Authorization': apiToken}})
      .map(result => result);
  }


}




// WEBPACK FOOTER //
// ./src/app/forms/elements/co2detail/co2detail.service.ts